// extracted by css-extract-rspack-plugin
export default {"button":"D00TE"};